export default __webpack_public_path__ + "static/media/message-circle.e6d37d40.svg";